module.exports = __webpack_public_path__ + "static/media/sales-stream-coin.18b929de.svg";